import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "table-responsive border-bottom mb-9" }
const _hoisted_2 = { class: "table mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom fs-6 fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-175px pb-2" }, "Cost name"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end pb-2" }, "Amount")
  ])
], -1)
const _hoisted_4 = { class: "fw-bold text-gray-700 fs-5 text-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "d-flex align-items-center pt-6" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-success fs-2 me-2" }),
  /*#__PURE__*/_createTextVNode("Client invoice")
], -1)
const _hoisted_6 = { class: "pt-6 text-success fw-bolder" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center vertical-align-mid"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-danger fs-2 me-2" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "vertical-align-mid"
}
const _hoisted_10 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_11 = { class: "fs-5 text-danger fw-bolder" }
const _hoisted_12 = {
  key: 2,
  colspan: "2"
}
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "d-flex w-75" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "d-flex justify-content-end flex-fill" }
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border m-5 text-white",
  style: {"width":"1.5rem","height":"1.5rem"}
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "svg-icon svg-icon-white svg-icon-2x"
}
const _hoisted_24 = { colspan: "2" }
const _hoisted_25 = { class: "d-flex justify-content-center" }
const _hoisted_26 = { class: "cursor-pointer d-flex flex-row align-items-center" }
const _hoisted_27 = { class: "svg-icon svg-icon-3 svg-icon-primary" }
const _hoisted_28 = { class: "fw-bold text-gray-700 fs-5 text-end" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-danger fs-2 me-2" }),
  /*#__PURE__*/_createTextVNode("Worker salaries")
], -1)
const _hoisted_30 = { class: "fs-5 text-danger fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_IconCheck = _resolveComponent("IconCheck")!
  const _component_PlusSign = _resolveComponent("PlusSign")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.realClientInvoice != null ? _ctx.realClientInvoice : _ctx.clientInvoice) + " " + _toDisplayString(_ctx.clientCurrency ? _ctx.clientCurrency.code : ''), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalCosts, (cost) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "py-2 fw-bold text-gray-700 fs-5 text-end",
            key: cost.id
          }, [
            (typeof cost.id == 'number')
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(_toDisplayString(cost.name), 1)
                ]))
              : _createCommentVNode("", true),
            (typeof cost.id == 'number')
              ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, "- " + _toDisplayString(cost.amount) + " " + _toDisplayString(_ctx.clientCurrency ? _ctx.clientCurrency.code : ''), 1),
                    (_ctx.$can('can_delete_additional_cost','all'))
                      ? (_openBlock(), _createBlock(_component_DeleteButton, {
                          key: 0,
                          onClick: ($event: any) => (_ctx.$emit('delete-existing-cost', cost)),
                          dynamicClass: 'cursor-pointer svg-icon-danger ms-3 mb-5px',
                          svgSize: 'svg-icon-2'
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Enter name",
                        "onUpdate:modelValue": ($event: any) => ((cost.name) = $event),
                        type: "text",
                        class: "form-control me-3 form-check-input h-30px w-100"
                      }, null, 8, _hoisted_15), [
                        [_vModelText, cost.name]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Enter amount",
                        "onUpdate:modelValue": ($event: any) => ((cost.amount) = $event),
                        type: "number",
                        class: "form-control form-check-input h-30px w-100"
                      }, null, 8, _hoisted_16), [
                        [_vModelText, cost.amount]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        disabled: _ctx.isSaving.includes(cost.id),
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('delete-new-cost', cost.id)), ["prevent"]),
                        class: "btn h-30px btn-icon btn-bg-danger btn-active-color-light btn-sm me-1"
                      }, [
                        _createVNode(_component_DeleteButton, {
                          dynamicClass: 'svg-icon-white',
                          svgSize: 'svg-icon-2'
                        })
                      ], 8, _hoisted_18),
                      _createElementVNode("button", {
                        disabled: _ctx.isSaving.includes(cost.id),
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('save-costs', cost)), ["prevent"]),
                        class: "btn h-30px btn-icon btn-bg-success btn-active-color-light btn-sm me-1"
                      }, [
                        (_ctx.isSaving.includes(cost.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createVNode(_component_IconCheck)
                            ]))
                      ], 8, _hoisted_19)
                    ])
                  ])
                ]))
          ]))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, [
                  _createVNode(_component_PlusSign)
                ]),
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add-new-cost'))),
                  class: "fs-4 ms-3"
                }, "Add new cost")
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("td", _hoisted_30, "- " + _toDisplayString(_ctx.workerSalaries) + " " + _toDisplayString(_ctx.clientCurrency ? _ctx.clientCurrency.code : ''), 1)
        ])
      ])
    ])
  ]))
}